import { Component, Injector, Input, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '../../base.component';

@Component({
	selector: 'CustomscriptInjectionHtml',
	templateUrl: './custome-script-injection-html.component.html',
	styleUrls: ['./custome-script-injection-html.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class CustomeScriptInjectionHtmlComponent extends BaseComponent {
	@Input() content: any;
	@Input() control: control;
	@Input() gtmEventData: any;

	constructor(injector: Injector) {
		super(injector);
	}

	async ngOnInit() {
		if (this.control.disabled) {
			setTimeout(() => {
				const elements = this.elementRef.nativeElement.querySelectorAll('a');
				for (let el of elements) {
					if (el) {
						el.classList.add('disabled');
						el.removeAttribute('href');
						el.removeAttribute('target');
					}
				}
			}, 0);
			return;
		}

		if (this.control.attributes.injectToOtherCompopnent) {
			var injectTo = document.querySelector(this.control.attributes.injectToOtherCompopnent);
			if (injectTo) {
				let temp = this.Renderer.createElement('span');
				temp.innerHTML = this.control.attributes.content;
				this.Renderer.appendChild(injectTo.parentElement, temp);
			}
		}

		const script = this.Renderer.createElement('script');
		script.src = this.control.attributes.scriptUrl;
		this.Renderer.appendChild(document.head, script);
	}
}
